import { minLength, required } from 'vuelidate/lib/validators'

const nameAreas = {
  name: { required },
  areas: {
    required,
    minLength: minLength(1)
  }
}
const nameAreaType = {
  name: { required },
  area: { required },
  type: { required }
}

export const projectModel = { form: { ...nameAreas, code: {} } }
export const packageModel = { form: nameAreas }
export const typeModel = { form: nameAreas }
export const workstreamModel = { form: nameAreaType }
export const categoryModel = { form: nameAreaType }
export const guaranteeNameModel = { form: { name: { required } } }
export const accessModel = {
  form: {
    user: { required },
    project: { required }
  }
}

export const currencyModel = {
  form: { code: { required } }
}
